import { render, staticRenderFns } from "./DaySelector.vue?vue&type=template&id=00a8a884&scoped=true&"
import script from "./DaySelector.vue?vue&type=script&lang=js&"
export * from "./DaySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a8a884",
  null
  
)

export default component.exports